import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

import { isNil } from '../../../utils/utils';
import { ApiInfoMessage } from './models/api-info-message.interface';
import { CustomerMetadata } from './models/customer-metadata.interface';
import { catchError, firstValueFrom, of } from 'rxjs';
import { concatMap, map } from 'rxjs/operators';

export interface DashboardInfo {
  active: number;
  text: string;
  status: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class DashboardInfoService {
  private http = inject(HttpClient);

  getInfoMessage(customerId: number): any {
    return this.getCustomerMetadata(customerId).pipe(
      concatMap(metadata => {
        // Country will be null for german customers to avoid stupid database filling
        return this.http.get<ApiInfoMessage>(
          `${environment.url.bffV3}/portalinfo/${metadata.country ?? 'de'}`
        );
      })
    );
  }

  private getCustomerMetadata(customerId: number) {
    return this.http.get<CustomerMetadata>(
      `${environment.url.bffV3}/customer/${customerId}/metadata`
    );
  }

  public async getCustomerCountry(customerId: number): Promise<string> {
    const metadata$ = this.getCustomerMetadata(customerId).pipe(
      map(metadata => {
        if (metadata?.country && !isNil(metadata.country)) {
          return metadata.country;
        }
        return 'de';
      }),
      catchError(() => of('de'))
    );

    return await firstValueFrom(metadata$);
  }

  /*public async getCustomerCountry(customerId: number): Promise<string> {
    return new Promise(resolve => {
      this.getCustomerMetadata(customerId).subscribe(metadata => {
        if (metadata.hasOwnProperty('country') && !isNil(metadata.country)) {
          resolve(metadata.country);
        } else {
          resolve('de');
        }
      });
    });
  }*/
}
